$(document).ready(function() {
    if ($('body.page-medico').length) {

        $('body').scrollspy({
            target: '#navbar-medico-box',
            offset: 60
        })

        qp = getQueryParams();
        if(qp.hasOwnProperty('widget')) {
            let location = window.location; 
            const idMedico = location.pathname.split('/')[2];
            if (!idMedico) return;
            httpRequest(api_url + 'frontend/widget-medico', {widget: qp.widget, id: idMedico}, {showLoader: false}).then(data => {
                
            })
        }
    }
});

selectPrestazione = function(id) {
    if (!window.appListe) return;
    window.appListe.$refs.disponibilitamedico.selectPrestazione({ID: id});
    $('#modalPrestVideoConsulti').modal('hide');

}
